export const data = [
  {
    make: "Mercedes",
    models: [
      {
        modelName: "A-Class",
        years: ["W176 (2012-2018)", "W177 (2018-present)"],
      },
      {
        modelName: "B-Class",
        years: ["W246 (2011-2018)", "W247 (2019-present)"],
      },
      { modelName: "C-Class", years: ["W205 (2014-present)"] },
      {
        modelName: "CLA-Class",
        years: ["C117 (2013-2019)", "C118 (2019-present)"],
      },
      {
        modelName: "CLS-Class",
        years: ["C218 (2010-2018)", "C257 (2018-present)"],
      },
      {
        modelName: "E-Class",
        years: ["W211 (2002-2009)", "W212 (2009-2016)", "W213 (2016-present)"],
      },
      {
        modelName: "GLA-Class",
        years: ["X156 (2014-2020)", "H247 (2020-present)"],
      },
      { modelName: "GLC-Class", years: ["X253 (2015-present)"] },
      {
        modelName: "GLE-Class",
        years: ["W166 (2011-2019)", "W167 (2019-present)"],
      },
      {
        modelName: "GLS-Class",
        years: ["X166 (2012-2019)", "X167 (2019-present)"],
      },
      { modelName: "GLK-Class", years: ["X204 (2008-2015)"] },
      { modelName: "SLK-Class", years: ["R172 (2011-2020)"] },
      {
        modelName: "S-Class",
        years: ["W222 (2013-2020)", "W223 (2021-present)"],
      },
      { modelName: "SL-Class", years: ["R231 (2012-present)"] },
    ],
  },
  {
    make: "BMW",
    models: [
      {
        modelName: "1-Series",
        years: ["E87 (2004-2011)", "F20 (2011-2019)", "F40 (2019-present)"],
      },
      {
        modelName: "2-Series",
        years: ["F22 (2013-present)", "F44 (2019-present)"],
      },
      {
        modelName: "3-Series",
        years: ["F30 (2011-2019)", "G20 (2019-present)"],
      },
      {
        modelName: "4-Series",
        years: ["F32 (2013-2020)", "G22 (2020-present)"],
      },
      {
        modelName: "5-Series",
        years: ["F10 (2010-2016)", "G30 (2016-present)"],
      },
      {
        modelName: "6-Series",
        years: ["F12 (2011-2018)", "G32 (2017-present)"],
      },
      { modelName: "7-Series", years: ["G11 (2015-present)"] },
      { modelName: "8-Series", years: ["G14 (2018-present)"] },
      { modelName: "X1", years: ["E84 (2009-2015)", "F48 (2015-present)"] },
      { modelName: "X3", years: ["F25 (2010-2017)", "G01 (2017-present)"] },
      { modelName: "X4", years: ["F26 (2014-2018)", "G02 (2018-present)"] },
      {
        modelName: "X5",
        years: ["E70 (2006-2013)", "F15 (2013-2018)", "G05 (2018-present)"],
      },
      {
        modelName: "X6",
        years: ["E71 (2008-2014)", "F16 (2014-2019)", "G06 (2019-present)"],
      },
      { modelName: "Z4", years: ["E89 (2009-2016)", "G29 (2019-present)"] },
    ],
  },
  {
    make: "Volkswagen",
    models: [
      { modelName: "Golf", years: ["MK7 (2012-2020)", "MK8 (2020-present)"] },
      { modelName: "Polo", years: ["MK5 (2009-2017)", "MK6 (2017-present)"] },
      { modelName: "Passat", years: ["B8 (2014-present)"] },
      { modelName: "Tiguan", years: ["MK1 (2007-2017)", "MK2 (2016-present)"] },
      { modelName: "Touran", years: ["MK2 (2010-2015)", "MK3 (2015-present)"] },
      { modelName: "Arteon", years: ["3H (2017-present)"] },
      { modelName: "Up!", years: ["MK1 (2011-present)"] },
      { modelName: "Scirocco", years: ["MK3 (2008-2017)"] },
      { modelName: "Transporter", years: ["T6 (2015-present)"] },
      { modelName: "Caddy", years: ["MK4 (2015-present)"] },
      { modelName: "T-Roc", years: ["MK1 (2017-present)"] },
    ],
  },
  {
    make: "Opel",
    models: [
      { modelName: "Corsa", years: ["D (2006-2014)"] },
      { modelName: "Astra", years: ["J (2009-2015)"] },
      { modelName: "Insignia", years: ["A (2008-2017)"] },
      { modelName: "Zafira", years: ["B (2005-2014)"] },
      { modelName: "Mokka", years: ["X (2012-2019)"] },
      { modelName: "Adam", years: ["S (2014-2019)"] },
      { modelName: "Meriva", years: ["B (2010-2017)"] },
      { modelName: "Crossland X", years: ["P1 (2017-present)"] },
      { modelName: "Grandland X", years: ["P1 (2017-present)"] },
    ],
  },
];
